import React from 'react'
import PropTypes from 'prop-types'

import ProductAnalyticsTierElement from './ProductAnalyticsTierElement'

function ProductAnalyticsTiers({ tiersData, tierRule, tabSwitch }) {
  const ruleInfo = tiersData.meta.tiers.find(info => info.rule === tierRule)

  return (
    <div className="tiers-container">
      <h2 className="content-heading__h2">
        To access {ruleInfo.feature}, you need to reach <strong>Tier {ruleInfo.requiredUserLevel}</strong>.
      </h2>
      <p className="tiers-subheading">{ruleInfo.description}</p>

      <div className="row tiers-levels">
        <div className="col-12 col-md-10 offset-md-1">
          <div className="row">
            {tiersData.data.tiers.map((tier) => {
              if (tier.id !== 0) {
                return (
                  <ProductAnalyticsTierElement
                    key={tier.id}
                    tiersData={tiersData}
                    tierInfo={tier}
                    userInfo={tiersData.data.user}
                    tierRule={tierRule}
                    tabSwitch={tabSwitch}
                  />
                )
              }
            })}
          </div>
        </div>
      </div>

      <p className="tiers-note"><strong>Note:</strong> Your Tier status is updated in real time. Unpublishing models or
        a drop in average publishing score can lead to a loss of Analytics feature accessibility.
      </p>
    </div>
  )
}

ProductAnalyticsTiers.propTypes = {
  tiersData: PropTypes.object.isRequired,
  tierRule: PropTypes.number.isRequired,
  tabSwitch: PropTypes.func.isRequired,
}

export default ProductAnalyticsTiers
